import { Address } from '../../../../global/dto/shared-data-model';
import { ApiStatuses } from '../../../../global/models/api-model';
import { LocksModel } from '../../../../global/models/locked-page-model';
import { ListItem } from '../../../../search/search-model';

export enum PositionTypes {
	Stipendiary,
	NonStipendiary,
}

export interface EmploymentItem {
	id: number;
	start_date: string;
	end_date: string;
}

export interface Position extends EmploymentItem {
	employment_id: number,
	position_title: string,
	published_title?: string,
}
export interface UnpaidLeave {
	id: number,
	employment_id: number,
	start_date: string,
	end_date: string,
}

export interface ScheduledHours extends EmploymentItem {
	employment_id: number;
	hours: number;
}

export interface Employment {
	id: number,
	employee_client_number: string,
	employer_client_number: string,
	employer_name: string,
	employee_name: string,
	employer_street_address: string,
	employer_location: string,
	employer_country: string,
	hire_date: string,
	hire_reason: string,
	termination_date: string,
	termination_reason: string,
	severance_start_date: string,
	severance_end_date: string,
	current_scheduled_hours: string,
	current_scheduled_hours_start_date: string,
	current_exempt_status: string,
	current_exempt_status_start_date: string,
	current_position_title: string,
	current_position_title_start_date: string,
	position_titles: Position[],
	scheduled_hours: ScheduledHours[],
	exempt_statuses: string[],
	unpaid_leaves: UnpaidLeave[],
	locks?: LocksModel,
	employer_guid?: string,
	employee_guid?: string,
	non_stipendiary_position_id? : number,
}

export interface Employee extends ListItem {
	guid: string,
	employment_id: number,
	list_order: number,
	blocked: boolean,
	removable: boolean,
	status_indicator: string,
	stipendiary_status: boolean,
	non_stipendiary_position: boolean,
	o_party_id: string,
	date_of_birth: string,
	status: string,
	designation: string,
	salutation: string,
	first_name: string,
	middle_name: string,
	last_name: string;
	suffix: string,
	client_number: string,
	full_name: string,
	address: Address,
	tooltips: any,
	employmentType?: string,
	masked_client_number?: string,
	masked_date_of_birth?: string,
	masked_ssn?: string,
	office_email_address?: string,
	personal_email_address?: string,
	statusDisplay?: string,
	fullAddress?: string;
	locks?: LocksModel;
	masked_client_nbr?: string,
}

export interface EmploymentState {
	employeeList: Employee[];
	currentEmployee: Employee;

	currentEmployment: Employment,
	employmentLoaded: boolean,

	nonStipendiaryEmployment: Employment,
	nonStipEmploymentLoaded: boolean,
	updateScheduledHoursStatus: ApiStatuses,
	updateStipPositionStatus: ApiStatuses,
	updateNonstipPositionStatus: ApiStatuses,
	addUnpaidLeaveSuccess: ApiStatuses,
	decreaseInSchduledHourStatus?: ApiStatuses,
}

export const noValueOnCompensation = '$0.00';
export const noDateOnCompensation = '9999-12-31';

export enum EmploymentStateActions {

	SET_EMPLOYMENT = 'SET_EMPLOYMENT_HISTORY',
	SET_EMPLOYMENT_FAIL = 'SET_EMPLOYMENT_HISTORY_FAIL',

	SET_EMPLOYEE_LIST = 'SET_EMPLOYEE_LIST',
	SET_CURRENT_EMPLOYEE = 'SET_CURRENT_EMPLOYEE',

	UPDATE_SCHEDULED_HOURS = 'UPDATE_SCHEDULED_HOURS',
	UPDATE_SCHEDULED_HOURS_STATUS = 'UPDATE_SCHEDULED_HOURS_STATUS',

	UPDATE_STIP_POSITION = 'UPDATE_STIP_POSITION',
	UPDATE_STIP_POSITION_STATUS = 'UPDATE_STIP_POSITION_STATUS',
	SET_NON_STIPENDIARY_EMPLOYMENT = 'SET_NON_STIPENDIARY_EMPLOYMENT',
	UPDATE_NON_STIP_POSITION = 'UPDATE_NON_STIP_POSITION',
	UPDATE_NON_STIP_POSITION_STATUS = 'UPDATE_NON_STIP_POSITION_STATUS',
	SET_UNPAID_LEAVES = 'SET_UNPAID_LEAVES',
	SET_ADD_UNPAID_LEAVES_STATUS = 'SET_ADD_UNPAID_LEAVES_STATUS',
	UNSET_EMPLOYMENT_STATE = 'UNSET_EMPLOYMENT_STATE',
	REMOVE_STIP_EMPLOYMENT = 'REMOVE_STIP_EMPLOYMENT',
	REMOVE_NON_STIP_EMPLOYMENT = 'REMOVE_NON_STIP_EMPLOYMENT',
	DECREASE_IN_SCHEDULED_HOURS = 'DECREASE_IN_SCHEDULED_HOURS',

}